module.exports = __webpack_public_path__ + "static/media/icon_extension_docx.3f2e3c4e.svg";